import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const UrlParamsProviderWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UrlParamsProviderWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idWorkspace"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idWorkspace"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberHeader"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"products"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"UrlParamsProviderWorkspace","document":UrlParamsProviderWorkspaceDocument}} as const;
export type UrlParamsProviderWorkspaceQueryVariables = Types.Exact<{
  idWorkspace: Types.Scalars['ID'];
}>;


export type UrlParamsProviderWorkspaceQuery = (
  { __typename: 'Query' }
  & { organization?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'id' | 'products'>
  )> }
);




/**
 * __useUrlParamsProviderWorkspaceQuery__
 *
 * To run a query within a React component, call `useUrlParamsProviderWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUrlParamsProviderWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUrlParamsProviderWorkspaceQuery({
 *   variables: {
 *      idWorkspace: // value for 'idWorkspace'
 *   },
 * });
 */
export function useUrlParamsProviderWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<UrlParamsProviderWorkspaceQuery, UrlParamsProviderWorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UrlParamsProviderWorkspaceQuery, UrlParamsProviderWorkspaceQueryVariables>(UrlParamsProviderWorkspaceDocument, options);
      }
export function useUrlParamsProviderWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UrlParamsProviderWorkspaceQuery, UrlParamsProviderWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UrlParamsProviderWorkspaceQuery, UrlParamsProviderWorkspaceQueryVariables>(UrlParamsProviderWorkspaceDocument, options);
        }
export type UrlParamsProviderWorkspaceQueryHookResult = ReturnType<typeof useUrlParamsProviderWorkspaceQuery>;
export type UrlParamsProviderWorkspaceLazyQueryHookResult = ReturnType<typeof useUrlParamsProviderWorkspaceLazyQuery>;
export type UrlParamsProviderWorkspaceQueryResult = Apollo.QueryResult<UrlParamsProviderWorkspaceQuery, UrlParamsProviderWorkspaceQueryVariables>;